import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { allRoutes } from '../../../routing/All_Routes'

const TeamReportTabs = () => {
    const location = useLocation()
    return (
        <div className='card ss-analytics-tabs-card' style={{ borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }}>
            <div className='ss-analytics-tabs-scroll-wrap ss-mobile-scroll-tabs px-3 px-sm-6 px-lg-8 border-bottom py-2'>
                <div className='btn-group ss-analytics-tabs ss-user-tab-group' role='group' aria-label='Team report tabs'>
                    <Link
                        className={`btn btn-sm text-nowrap ${
                            location.pathname === `${allRoutes.analytics}/team-report/expense-summary`
                                ? 'btn-primary'
                                : 'btn-light-primary'
                        }`}
                        to={`${allRoutes.analytics}/team-report/expense-summary`}
                    >
                        Expense Summary
                    </Link>
                    <Link
                        className={`btn btn-sm text-nowrap ${
                            location.pathname === `${allRoutes.analytics}/team-report/expense-detail`
                                ? 'btn-primary'
                                : 'btn-light-primary'
                        }`}
                        to={`${allRoutes.analytics}/team-report/expense-detail`}
                    >
                        Expense Detail
                    </Link>
                    <Link
                        className={`btn btn-sm text-nowrap ${
                            location.pathname === `${allRoutes.analytics}/team-report/expense-by-category`
                                ? 'btn-primary'
                                : 'btn-light-primary'
                        }`}
                        to={`${allRoutes.analytics}/team-report/expense-by-category`}
                    >
                        Expense By Category
                    </Link>
                    <Link
                        className={`btn btn-sm text-nowrap ${
                            location.pathname === `${allRoutes.analytics}/team-report/expense-violations`
                                ? 'btn-primary'
                                : 'btn-light-primary'
                        }`}
                        to={`${allRoutes.analytics}/team-report/expense-violations`}
                    >
                        Expense Violations
                    </Link>
                    <Link
                        className={`btn btn-sm text-nowrap ${
                            location.pathname === `${allRoutes.analytics}/team-report/category-budget`
                                ? 'btn-primary'
                                : 'btn-light-primary'
                        }`}
                        to={`${allRoutes.analytics}/team-report/category-budget`}
                    >
                        Category Budget
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default TeamReportTabs